import { Link } from 'react-router-dom'
import {
  useListProblemOccurrencesQuery,
  useWorkScope
} from '@axilon-apps/domains-ontology-ui-state'
import { occurrenceHref } from '../../../lib/component-links'
import { formatRelativeTime } from '../../../lib/time'
import { OccurrenceTasks, WorkError } from '../../../components/problem-work/OccurrenceTasks'
import { SectionHeader } from '../entity/SectionHeader'

export function OpenProblemsSection({ equipmentId }: { equipmentId: string }) {
  const scope = useWorkScope()
  const query = useListProblemOccurrencesQuery(
    { ...scope, entityId: equipmentId },
    { skip: !equipmentId }
  )
  if (query.isError)
    return (
      <WorkError message="Couldn't load related problems." retry={() => void query.refetch()} />
    )
  const problems = query.currentData?.filter((problem) => problem.status === 'open') ?? []
  if (!problems.length) return null
  return (
    <section>
      <SectionHeader
        label="Open problems"
        subtitle={`${problems.length} ${problems.length === 1 ? 'occurrence' : 'occurrences'}`}
      />
      <div className="flex flex-col gap-3 rounded-xl border border-st-down/30 bg-card p-5 text-card-foreground shadow-sm">
        {problems.map((problem) => (
          <div key={problem.id} className="min-w-0">
            <Link
              to={occurrenceHref(problem.id)}
              className="text-13 font-medium text-ink no-underline hover:text-brand hover:underline"
            >
              {problem.problem_name}
            </Link>
            <div className="mb-2 mt-0.5 text-12 text-ink-3">
              Opened {formatRelativeTime(problem.opened_at)}
            </div>
            <OccurrenceTasks scope={scope} occurrence={problem} collapsible readOnly details />
          </div>
        ))}
      </div>
    </section>
  )
}
